/**
 * Element / Document / DocumentFragment.prototype.replaceChildren for Safari and iOS before 14.
 * Removes the children of the node, then appends the given nodes or strings (as text).
 */
export const polyfillReplaceChildren = () => {
    const prototypes = [Element.prototype, Document.prototype, DocumentFragment.prototype];

    for (const prototype of prototypes) {
        if (!prototype.replaceChildren) {
            Object.defineProperty(prototype, 'replaceChildren', {
                configurable: true,
                writable: true,
                value: function(...nodes) {
                    while (this.lastChild) {
                        this.removeChild(this.lastChild);
                    }
                    this.append(...nodes);
                }
            });
        }
    }
};
